import routes from "../routes/routes";

export const menuConfig = [
  {
    id: "paciente",
    label: "Paciente",
    allowWithoutPermission: true,
    children: [
      {
        id: "buscar_paciente",
        label: "Buscar paciente",
        route: "menu:buscar_paciente",
        action: { type: "dispatchEvent", event: "open-search-modal" },
      },
      {
        id: "asignar_grupo",
        label: "Asignar a grupo",
        route: "menu:asignar_grupo",
        action: { type: "dispatchEvent", event: "open-group-modal" },
      },
      {
        id: "exportar_caso",
        label: "Exportar Caso",
        route: "menu:exportar_caso",
        children: [
          {
            id: "exportar_pdf",
            label: "PDF",
            route: "menu:exportar_pdf",
          },
          {
            id: "exportar_csv",
            label: "CSV",
            route: "menu:exportar_csv",
          },
        ],
      },
      {
        id: "cerrar_sesion",
        label: "Cerrar Sesion",
        allowWithoutPermission: true,
        action: { type: "context", func: "logout" },
      },
    ],
  },
  {
    id: "configuracion",
    label: "Configuración",
    route: "menu:configuracion",
    children: [
      {
        id: "cargar_datos",
        label: "Cargar datos masivos",
        route: "menu:cargar_datos",
        children: [
          {
            id: "pacientes",
            label: "Pacientes",
            route: routes.carguePacientesMasivos,
          },
          {
            id: "resultados",
            label: "Resultados",
            route: routes.resultados,
          },
        ],
      },
      {
        id: "tamano_letra",
        label: "Tamaño letra",
        allowWithoutPermission: true,
        children: [
          { id: "font_small", label: "Pequeña", allowWithoutPermission: true, action: { type: "local", func: "handleFontSizeChange", args: ["11px"] } },
          { id: "font_standard", label: "Estándar", allowWithoutPermission: true, action: { type: "local", func: "handleFontSizeChange", args: ["13px"] } },
          { id: "font_medium", label: "Mediana", allowWithoutPermission: true, action: { type: "local", func: "handleFontSizeChange", args: ["15px"] } },
          { id: "font_large", label: "Grande", allowWithoutPermission: true, action: { type: "local", func: "handleFontSizeChange", args: ["18px"] } },
        ],
      },
      {
        id: "maestros",
        label: "Maestros",
        route: routes.maestro,
      },
      {
        id: "logs_sincronizador",
        label: "Logs Sincronizador",
        route: routes.logsServicios,
      },
    ],
  },
  {
    id: "registros",
    label: "Registros",
    route: "menu:registros",
    children: [
      {
        id: "registro_pai",
        label: "Registro PAI",
        route: routes.paiRegistro,
      },
      {
        id: "plan_parto",
        label: "Plan de parto",
        route: routes.planParto,
      },
      {
        id: "citologia",
        label: "Citología",
        route: routes.citologia,
      },
    ],
  },
  {
    id: "analitica",
    label: "Analítica",
    route: "menu:analitica",
    children: [
      {
        id: "indicadores",
        label: "Indicadores",
        route: routes.dashboard,
      },
      {
        id: "indicador",
        label: "Indicador",
        route: routes.indicadorGubernamental,
      },
      {
        id: "reportes",
        label: "Reportes",
        route: "menu:reportes",
        children: [
          {
            id: "reportes_generales",
            label: "Reportes Generales",
            route: routes.informe,
          },
          {
            id: "reportes_normativos",
            label: "Reportes Normativos",
            route: routes.reportesNormativos,
          },
        ],
      },
    ],
  },
  {
    id: "herramientas",
    label: "Herramientas",
    route: "menu:herramientas",
    children: [
      {
        id: "base_documental",
        label: "Base Documental",
        route: routes.baseDocumental,
      },
      {
        id: "calculadoras",
        label: "Calculadoras",
        route: routes.calculadora,
      },
      {
        id: "enlaces",
        label: "Enlaces",
        route: routes.enlaces,
      },
    ],
  },
  {
    id: "ayuda",
    label: "Ayuda",
    route: "menu:ayuda",
    children: [
      {
        id: "soporte",
        label: "Soporte técnico",
        route: routes.soporte,
      },
      {
        id: "acerca_de",
        label: "Acerca de…",
        allowWithoutPermission: true,
        route: routes.error,
      },
    ],
  },
];
